import cookie from "react-cookies";
export const appId = cookie.load("companyUniqueID");
export const apiUrl = process.env.REACT_APP_API_URL;
export const siteMainURL = process.env.REACT_APP_SITE_MAIN_URL;
export const baseUrl = process.env.REACT_APP_BASE_URL;

export const deliveryId = "e405c6e5-1526-443d-8809-e149df521133";
export const pickupId = "962ac11f-aaf3-4ba0-8417-b7efb812b939";
export const CountryTxt = "Singapore";
export const productNoImg = "/img/product-noimg.jpg";
export const adminlimit = "10";

var accesstoken = {
  Authorization: `Bearer ${cookie.load("accessToken")}`,
};
export const masterheaderconfig = {
  headers: accesstoken,
};
var clientaccesstoken = {
  Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
};
export const clientheaderconfig = {
  headers: clientaccesstoken,
};
